import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import ForbiddenPage from "../components/ForbiddenPage";
import { canAccessCrm, isCrmPath } from "../utils/crmAccess";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading, user } = useContext(AuthContext);
	if (loading) return <BackdropLoading />;

	if (!isAuth && isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
			</>
		);
	}

	if (isAuth && !isPrivate) {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
			</>
		);
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} render={props => isPrivate && isCrmPath(props.location.pathname, props.location.search) && !canAccessCrm(user) ? <ForbiddenPage /> : <Component {...props} />} />
		</>
	);
};

export default Route;
